export enum recruitmentsStatusChangeTypes {
  FETCH_RECRUIMENTS_STATUS_CHANGE_REQUEST = "FETCH_RECRUIMENTS_STATUS_CHANGE_REQUEST",
  FETCH_RECRUIMENTS_STATUS_CHANGE_SUCCESS = "FETCH_RECRUIMENTS_STATUS_CHANGE_SUCCESS",
  FETCH_RECRUIMENTS_STATUS_CHANGE_FAILURE = "FETCH_RECRUIMENTS_STATUS_CHANGE_FAILURE",
}